// Televisit vs office visit on the patient timeline (owner 10-13: "differentiate office visit vs
// televisit"). No extra request: the v2 encounters list (/v1/fhir-mirror/.../encounter) already
// carries everything needed.
//  - `istelevisit` (v2 10-13+): FHIR Encounter.class VR OR the local appointment purpose
//    (9928 TELEHEALTH / TELEHEALTH-<provider>, 7825 "Telemedicine f/u|Consult|New Pt"). Authoritative.
//  - older v2 (no `istelevisit`): `patientlocation` = Encounter.class code ("VR" = virtual), and the
//    type / visit-name / appointment-type text.
// BlinkScribe-only rows (no Athena encounter) stay "Visit".
export const TELE_RE = /TELE[\s-]*(?:HEALTH|MEDICINE|MED|VISIT)|\bTELE\b|VIRTUAL|VIDEO\s*VISIT/i;

export function isTelevisit(raw) {
  if (!raw || typeof raw !== "object" || raw.bsOnly) return false;
  if (typeof raw.istelevisit === "boolean") return raw.istelevisit;
  if (String(raw.patientlocation || "").trim().toUpperCase() === "VR") return true;
  const text = [raw.encountertype, raw.encountervisitname, raw.appointmenttypename, raw.appointmentpurpose, raw.purpose]
    .filter((v) => typeof v === "string").join(" ");
  return TELE_RE.test(text);
}

export const visitPillLabel = (raw) => (isTelevisit(raw) ? "Televisit" : "Visit");
